export default {
  CREATE_ON_BOARDING_CUSTOMER_AGREEMENT_REPOSITORY:
    Symbol.for('CREATE_ON_BOARDING_CUSTOMER_AGREEMENT_REPOSITORY'),
  CREATE_ON_BOARDING_CUSTOMER_AGREEMENT_COMMAND:
    Symbol.for('CREATE_ON_BOARDING_CUSTOMER_AGREEMENT_COMMAND'),
};
